import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { H1 } from '@hobs/components/Headings';
import Icon from '@hobs/components/Icon';
import Status from '@hobs/components/Status';
import { Link } from 'react-router-dom';
import Styles from './PageHeader.module.scss';

const Wrapper = ({ children, ...rest }) => {
  if (rest.to) {
    return (
      <Link className={Styles['back-link']} {...rest}>
        {children}
      </Link>
    );
  }

  return (
    <div className={Styles['back-link']} {...rest}>
      {children}
    </div>
  );
};

Wrapper.propTypes = {
  children: PropTypes.any.isRequired
};

function getFieldValue(value) {
  return value && value !== '' ? value : '-';
}

const PageHeader = ({
  title,
  to,
  onClick = null,
  status = null,
  order = null,
  unit = null,
  t,
  parent = null,
  accounting = null
}) => {
  const props = {
    className: Styles.link
  };

  if (to) {
    props.to = to;
  }

  if (onClick) {
    props.onClick = onClick;
  }

  return (
    <div className={Styles['page-header']}>
      <Wrapper {...props}>
        {(to || onClick) && <Icon icon="BackArrow" />}
        <H1>{title}</H1>
      </Wrapper>
      {unit && (
        <div className={Styles.unit}>
          {unit.code}, {unit.name} ({getFieldValue(unit.number)})
        </div>
      )}

      {order && <div className={Styles.order}>{order}</div>}

      {status && (
        <Status order={status.order} name={status.name} type={status.id} />
      )}

      {parent && (
        <div className={Styles.parent}>
          {t('Created from category')} (
          <Link to={parent.to}>{parent.title}</Link>)
        </div>
      )}
      {accounting &&
        (accounting.purchaseOrderNumber || accounting.positionNumber) && (
          <div className={Styles.parent}>
            {accounting.purchaseOrderNumber && (
              <React.Fragment>
                {t('PO No')}: {accounting.purchaseOrderNumber}{' '}
              </React.Fragment>
            )}
            {accounting.positionNumber && (
              <React.Fragment>
                {t('Pos No')}: {accounting.positionNumber}
              </React.Fragment>
            )}
          </div>
        )}
    </div>
  );
};

PageHeader.propTypes = {
  status: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.number,
    order: PropTypes.bool
  }),
  order: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  parent: PropTypes.shape({
    title: PropTypes.string,
    to: PropTypes.string
  }),
  unit: PropTypes.shape({
    code: PropTypes.string,
    number: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string
  }),
  accounting: PropTypes.shape({
    positionNumber: PropTypes.number,
    purchaseOrderNumber: PropTypes.number
  }),
  title: PropTypes.string.isRequired,
  to: PropTypes.string,
  onClick: PropTypes.func,
  t: PropTypes.func
};

export default withTranslation()(PageHeader);
